<template>
  <div class="message-card" @click="dealMsg">
    <!--1已读 字灰色-->
    <div class="list-icon fl pr">
      <b v-if="SelfMessageList.Status === 0" class="pa unRead-icon"></b>
      <van-icon name="bell" />
      <!--0未读 显示小红点-->
    </div>
    <div class="list-info">
      <h4 class="nowrap" v-cloak>
        {{ SelfMessageList.Subject }}
        <!-- <Icon type="ios-arrow-dropright-circle"></Icon> -->
      </h4>
      <span class="nowrap" v-html="SelfMessageList.MessageDescribe"></span>
      <p class="nowrap" v-cloak>
        接收时间：{{ xy.moment(SelfMessageList.CreateByDate).format('YYYY.MM.DD HH:mm') }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;触发者：{{
        SelfMessageList.SenderName
        }}
      </p>
      <p class="nowrap" v-cloak>模块：{{ SelfMessageList.MessageTypeName }}</p>
    </div>
    <div class="list-btn">
      <van-icon name="arrow" />
    </div>
  </div>
</template>
<script>
export default {
  name: "messageCard",
  props: {
    SelfMessageList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    pathSource: {
      type: String,
      default: ""
    },
    msgInfoNullShowFn: {
      type: Function,
      default: () => {}
    }
  },
  created() {
  },
  methods: {
    async dealMsg() {
      // 如果未读标记未读
      let messageRow = this.SelfMessageList;
      console.log(messageRow)
      if (messageRow.Status === 0) {
        let params = {
          status: 1
        };
        await this.xyapi.post(
           `${this.xyMApi}/msg/api/message/SetStatus?status=${params.status}&messageID=${this.SelfMessageList.MessageID}`
        );
      }
      //根据是否有地址来处理消息
      if (messageRow.DetailMobileUrl.length > 0) {
        if (messageRow.DetailMobileUrl === '/home/Doc/details') {
          this.$router.push({ path: messageRow.DetailMobileUrl, query: { docID: messageRow.BusinessID, msgTo: true } })
        } else if(messageRow.DetailMobileUrl === '/home/visitDetails') {
          this.$router.push({ path: messageRow.DetailMobileUrl, query: { VisitorRecordID: messageRow.BusinessID, msgTo: true } })
        }else {
          this.xy.msgError("请到PC端查看消息详情");
        }
        //跳转消息详情方法
        // this.viewDetails();
        
        // if (this.pathSource === "messageList") {
        //   this.goTuUrl(1);
        // } else if (this.pathSource === "XyIndex") {
        //   this.msgInfoNullShowFn();
        // }
        //this.goTuUrl(1);
      } else {
        this.xy.msgError("请到PC端查看消息详情");
        //this.viewDetails();
      }
    },
    // 消息跳转详情
    viewDetails() {
      let messageRow = this.SelfMessageList;
      // if (this.$store.state.apiPath !== messageRow.ServiceDoMainName) {
      //   this.$store.commit("changeApiPath", messageRow.ServiceDoMainName);
      // }
      this.$store.commit("changeMessageInfo", messageRow);
      // 消息路由跳转
      this.$router.push({
        path: messageRow.DetailMobileUrl,
        query: { fromMessage: true }
      });
    },
    goTuUrl(SourceType) {
      let MessageAppUrl =
        SourceType === 1 ? "" : this.SelfMessageList.WebDoMainName;
      this.$router.push({
        path: "/messageDetail",
        query: {
          MessageModel: JSON.stringify(this.SelfMessageList),
          MessageAppUrl: MessageAppUrl,
          SourceType: SourceType,
          type: "0",
          pathSource: this.pathSource
        }
      });
    }
  }
};
</script>
<style lang="less">
.message-card{
    .comm-title {
      display: inline;
      > span:nth-of-type(1) {
        display: inline-block;
        padding: 2px 10px;
        font-size: 24px;
        border-radius: 24px;
        color: #fff !important;
        margin-right: 6px;
      }
    }
    .pt {
      > span:nth-of-type(1) {
        background: #25c40b;
      }
    }
    .jj {
      > span:nth-of-type(1) {
        background: #f5222d;
      }
    }
}
.message-card {
  position: relative;

  .van-icon-bell:before {
    line-height: 36px;
  }
}

.news-list {
  margin: 22px 19px 0;
}

.news-list > .news-item {
  background: #fff;
  padding: 20px 40px 20px 10px;
  margin-top: 22px;
  margin-bottom: 16px;
  box-shadow: 0 2px 21px 0 rgba(197, 197, 197, 0.5);
  border-radius: 06px;
  position: relative;
}

.news-item .list-icon {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #98c1fb;
}

.news-item .list-icon i {
  color: #fff;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-item .list-icon b {
  display: inline-block;
  top: -0.04px;
  right: -0.02px;
  width: 12px;
  height: 12px;
  background: #ff9500;
  border-radius: 50%;
}

.news-item .list-info {
  padding-left: 60px;
  font-size: 26px;
}

.news-item .list-info h4 {
  min-height: 30px; /*无数据时留出高度*/
  font-size: 28px;
  color: #333;
  font-weight: normal;
  max-width: 85%;
}

.news-item .list-info > span {
  font-size: 26px;
  color: #666;
  margin: 15px 0 10px;
  display: block;
  max-width: 85%;
}

.news-item .list-info p {
  font-size: 22px;
  color: #b7b7b7;
  max-width: 85%;
}

.news-item .list-btn {
  position: absolute;
  top: 50%;
  right: 4px;
  width: 48px;
  transform: translateY(-50%);
  height: 48px;
  background: #4a98fd;
  box-shadow: 0 04px 12px 0 rgba(50, 133, 255, 0.41);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-item .list-btn i {
  font-size: 35px;
  color: #fff;
  display: flex;
}

.news-item.isRead .list-info h4,
.news-item.isRead .list-info span,
.news-item.isRead .list-info p {
  color: #999;
}

.nowrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
